<template>
  <Fragment>
    <AppMenu :menu-items="menuItems" />
    <AppBar :menu-items="menuItems" />

    <VMain>
      <slot />
    </VMain>
  </Fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import { Fragment } from 'vue-fragment'

import theme from '@/mixins/theme'
import { MenuItem } from '@/utils/menu'
import AppMenu from '@components/AppMenu.vue'
import AppBar from '@components/AppBar.vue'

import * as getters from '@/store/getters/types'

export default {
  name: 'GuestLayout',

  components: {
    Fragment,
    AppMenu,
    AppBar
  },

  mixins: [theme],

  computed: {
    ...mapGetters({
      vendor: getters.VENDOR
    }),

    menuItems () {
      return [
        new MenuItem({
          name: 'login',
          title: 'anonymous_sign_in.one',
          icon: 'login',
          to: '/login',
        }),

        new MenuItem({
          name: 'reset',
          title: 'anonymous_forgot_password.one',
          icon: 'lock_reset',
          to: '/reset',
        }),

        new MenuItem({
          name: 'register',
          title: 'anonymous_register_account.one',
          icon: 'person_add',
          to: '/register',
        }),

        new MenuItem({
          name: 'online_shop',
          title: 'online_shop.one',
          icon: 'shopping_cart',
          href: '/shop',
        }),
      ]
    }
  },

  created () {
    this.register()
  },

  methods: {
    register () {
      const branding = this.vendor?.branding

      if (branding) {
        this.useBrandingTheme(branding)
      }
    }
  }
}
</script>

<style lang="scss">

</style>
